import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'services/store/ai';
import type { RootState } from 'services/store';

const useDrawerState = () => {
  const dispatch = useDispatch();

  const isOpen = useSelector(
    (store: RootState) => store.ai.isFormulaDrawerOpened
  );

  const open = useCallback(() => {
    dispatch(actions.setFormulaDrawerState({ isOpen: true }));
  }, [dispatch]);

  const close = useCallback(() => {
    dispatch(actions.setFormulaDrawerState({ isOpen: false }));
  }, [dispatch]);

  return {
    isOpen,
    close,
    open,
  };
};

export default useDrawerState;
